import React from "react";

const About = () => {
  return (
    <section id="about">
      <h2>About Me</h2>
      <div className="aboutcontainer">
        <p>
          I'm J.M. Chathuranga Niroshana Jayathilaka, an enthusiastic
          undergraduate student at CINEC Campus, Malabe, Sri Lanka. Currently,
          pursuing a BSc (Hons) degree in Software Engineering. My journey in
          technology is fueled by a desire to excel as a skilled and innovative
          Web Developer. Keen on crafting elegant and efficient web solutions, I
          stay abreast of the latest technologies and methodologies, always
          eager for new challenges in web development.
        </p>
        <p>
          Motivated undergraduate at CINEC Campus, focusing on Software
          Engineering. Proficient in both Frontend and Backend development.
          Skills include crafting responsive interfaces and server-side
          functionality using technologies such as Mongoose, Express JS, Node
          JS, and React JS. Committed to continuous learning, demonstrated by
          certifications obtained from various online platforms and bootcamps.
        </p>
      </div>
    </section>
  );
};

export default About;
